export const PROJECT_STATUS_CODES = Object.freeze({
  NEW: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  MIGRATION_COMPLETED: 4,
  MIGRATION_FAILED: 5,
  SYNC_FAILED: 7,
  FAILED: 10,
  ON_HOLD: 11,
  INACTIVE: 12,
  INACTIVE_PENDING_NEEDS_APPROVAL: 13,
  ARCHIVED: 14,
  INACTIVE_PENDING_IN_PROGRESS: 15,
  REACTIVE_PENDING_IN_PROGRESS: 16,
  REACTIVE_PENDING_NEEDS_APPROVAL: 17,
  ARCHIVING_IN_PROGRESS: 18,
  UNARCHIVING_IN_PROGRESS: 19,
  ERROR_STATUS: 20,
  ARCHIVING_PENDING_NEEDS_APPROVAL: 1001,
  ARCHIVING_PENDING_FROM_INACTIVE_NEEDS_APPROVAL: 1002,
  ARCHIVING_PENDING_IN_PROGRESS: 1003,
  ARCHIVING_PENDING_FROM_INACTIVE_IN_PROGRESS: 1004,
  UNARCHIVING_PENDING_NEEDS_APPROVAL: 1005,
  UNARCHIVING_PENDING_IN_PROGRESS: 1006,
});
